
export { default } from './moveable';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/moveable/index.js
// module id = 1904
// module chunks = 1